import deepmerge from 'deepmerge';
import defaultTheme from './defaultTheme';
const overwriteMerge = (destinationArray, sourceArray, options) => sourceArray;
export default function createHoiPoiTheme() {
  let theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return deepmerge(defaultTheme, theme, {
    arrayMerge: overwriteMerge
  });
}